/**
 * FRIDGE-1311 — measures the "Summarize with" row: one PostHog event per press
 * of an assistant icon, with the assistant and the article path, so an icon
 * nobody uses can be dropped on evidence.
 *
 * The press goes through the same human filter as the search events
 * (lib/search/record-outcome.ts): consent first, then fridge.com only, no
 * automation flag, no bot or headless user agent. A filtered press, a missing
 * client or a capture that throws never stops the link from opening.
 *
 * Kept apart from lib/blog/summarize-with-ai.ts so the browser bundle carries
 * only this capture, not the link builder.
 */
import posthog from 'posthog-js'
import { isTelemetryAllowed } from '@/lib/consent/client'
import { allowSearchAnalytics } from '@/lib/search/analytics-privacy'

export const SUMMARIZE_WITH_EVENT = 'summarize_with_ai_clicked'

export function recordSummarizeWithClick(assistant: string, path: string): void {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return
  if (!assistant || !isTelemetryAllowed()) return
  const human = allowSearchAnalytics({
    hostname: window.location.hostname,
    pathname: window.location.pathname,
    userAgent: navigator.userAgent,
    automated: navigator.webdriver,
  })
  if (!human) return
  try {
    posthog?.capture?.(SUMMARIZE_WITH_EVENT, { assistant, path })
  } catch {
    /* measurement never blocks the link */
  }
}
